import {FC} from 'react'

import {getTmAcademyContent} from '@/content/tm-academy/tmAcademy'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {AcademyContents} from '@/utils/contentful'
import {useLanguage} from '@/utils/i18n/language'
import {TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {Text} from '../../common/content/Text'
import {SidebarCategory} from './SidebarCategory'

type SidebarProps = {
  contents: AcademyContents
  searchWords?: string[]
  onClick?: () => void
  isMobile?: boolean
}

export const Sidebar: FC<React.PropsWithChildren<SidebarProps>> = ({
  contents,
  searchWords,
  onClick,
  isMobile,
}) => {
  const {t} = useTranslation()
  const language = useLanguage()
  const {topicsTitle} = getTmAcademyContent(language)

  return (
    <>
      <div className="desktop">
        <Text color={theme.palette.text.light}>{t(topicsTitle)}</Text>
      </div>
      <div className="list">
        {contents.map(({slug, title, articles}) => (
          <div key={`category-${slug}`} className="item">
            <SidebarCategory
              title={title}
              articles={articles}
              searchWords={searchWords}
              onClick={onClick}
              isMobile={isMobile}
            />
          </div>
        ))}
      </div>

      <style jsx>{`
        .list {
          margin-top: ${theme.spacing[4]};
        }
        .item + .item {
          margin-top: ${theme.spacing[4]};
        }
        @media ${TABLET_SCREENSIZE} {
          .desktop {
            display: none;
          }
          .list {
            margin-top: -${theme.spacing[3]};
          }
          .item + .item {
            margin-top: 0;
            border-top: 1px solid ${theme.palette.gray[600]};
          }
          .item:last-of-type {
            padding-bottom: ${theme.spacing[3]};
          }
        }
      `}</style>
    </>
  )
}
